import * as Models from 'contracts/models';

export const Endpoint = () => `/api/v4/admin/partners/`;
export const QueryKey = () => ['v4', 'admin', 'partners'] as const;
export type Payload = never;
export type Response = Models.Partners.Partner[];
